import React from 'react';

import logo from '../../images/logo.svg'
import { Link } from 'react-router-dom';
import { Navbar, Nav, Offcanvas, Container } from 'react-bootstrap';




const PageNavbar = () => {
  
 
  return (
    <div>
      {['md'].map((expand) => (
        <Navbar key={expand} expand={expand} className='d-flex pe-5' style={{background:'#ccdff04d'}}>
          
          <Navbar.Brand>
            <Link to='/' >
              <img src={logo} />
            </Link>
          </Navbar.Brand>
          <Navbar.Toggle aria-controls={`offcanvasNavbar-expand-${expand}`} />
          <Navbar.Offcanvas 
              id={`offcanvasNavbar-expand-${expand}`}
              aria-labelledby={`offcanvasNavbarLabel-expand-${expand}`}
              placement="end" style={{ backgroundColor: 'white' }}
            >
              <Offcanvas.Header closeButton style={{ backgroundColor: 'white' }}>
                <Offcanvas.Title id={`offcanvasNavbarLabel-expand-${expand}`}>
                <Link to='/'>
                 <img src={logo}/>
                </Link>
                </Offcanvas.Title>
              </Offcanvas.Header>
             
              <Offcanvas.Body>
                <Nav className="justify-content-end flex-grow-1 pe-5 gap-4 me-5">
                  <Nav.Link><Link to='/' className='link-dark text-decoration-none'>Home</Link></Nav.Link>
                  <Nav.Link><Link to='/jobseekerlogin' className='link-dark text-decoration-none' >Find Jobs</Link></Nav.Link>
                 <Nav.Link ><Link to='/employerlogin' className='link-dark text-decoration-none'>Post Jobs</Link></Nav.Link>
                </Nav>           
              </Offcanvas.Body>
          </Navbar.Offcanvas>
          
        </Navbar>
      ))}
     
    </div>
   
   
   
    
  )

  
}

export default PageNavbar


